import {useEffect, useState} from "react"
import {Eye, EyeOff} from "react-feather";


const Password = (props) => {
    const {name, value, size, label, className, error, required, suffix, isReady, ...rest} = props
    const [inputValue, setInputValue] = useState('')
    const [isVisible, setIsVisible] = useState(false)


    const handleVisibility = () => {
        setIsVisible(!isVisible)
    }


    const handleChange = (ev) => {
        ev.preventDefault()
        setInputValue(ev.target.value)
    }


    useEffect(() => {
        setInputValue(value)
    }, [value])


    return (
        <div className="form-group">
            {label && <label>
                {required && <span className="text-red required">* </span>}
                {label}
                {error && <span className="error">{error}</span>}
            </label>}
            <div className="input-container">
                <input
                    name={name}
                    value={inputValue}
                    disabled={!isReady}
                    onChange={handleChange}
                    type={isVisible ? "text" : "password"}
                    className={`form-control ${!isReady ? 'is-loading' : ''} form-control-${size ? size : 'sm'} ${className ? className : ''}`}
                    {...rest}
                />

                {inputValue?.length > 0 && <a href="#" className="btn-addon" onClick={handleVisibility}>
                    {isVisible ? <Eye/> : <EyeOff/>}
                </a>}

                {suffix && <span className="suffix">{suffix}</span>}
            </div>
        </div>
    )
}

export default Password